var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4 py-md-5 px-4 px-md-5 bg-white"},[_c('preface')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }